<template>
  <v-card class="card" color="primary">
    <v-card-title>
      <v-container>
        <v-row align="center">
          <v-col cols="8">
            <div class="text-h5 font-weight-bold">Datos generales</div>
          </v-col>
          <v-col cols="4" align="right">
            <v-btn rounded color="secondary" @click="triggerUpdatePersonal"
              >Guardar cambios<v-icon small class="ml-4">mdi-pencil</v-icon></v-btn
            >
          </v-col>
        </v-row>
        <v-row>
          <v-col>
            <v-tabs v-model="selectedTab" color="secondary" fixed-tabs>
              <v-tab class="font-weight-bold">Información <br />principal</v-tab>
              <v-tab class="font-weight-bold">Nacionalidad</v-tab>
              <v-tab class="font-weight-bold">Documentación <br />oficial</v-tab>
              <v-tab class="font-weight-bold">Información <br />personal</v-tab>
              <v-tab class="font-weight-bold">Domicilio</v-tab>
              <v-tab class="font-weight-bold">Estudios</v-tab>
            </v-tabs>
          </v-col>
        </v-row>
      </v-container>
    </v-card-title>
    <v-card-text>
      <v-tabs-items v-model="selectedTab" class="transparent">
        <v-tab-item key="1" eager>
          <InformacionPrincipalTabContent />
        </v-tab-item>
        <v-tab-item key="2" eager>
          <NacionalidadTabContent />
        </v-tab-item>
        <v-tab-item key="3" eager>
          <DocumentacionOficialTabContent />
        </v-tab-item>
        <v-tab-item key="4" eager>
          <InformacionPersonalTabContent />
        </v-tab-item>
        <v-tab-item key="5" eager>
          <DomicilioTabContent />
        </v-tab-item>
        <v-tab-item key="6" eager>
          <EstudiosTabContent />
        </v-tab-item>
      </v-tabs-items>
    </v-card-text>
  </v-card>
</template>

<script>
import { mapActions, mapGetters } from 'vuex'
import InformacionPrincipalTabContent from './datos-generales/tab-content/InformacionPrincipalTabContent.vue'
import NacionalidadTabContent from './datos-generales/tab-content/NacionalidadTabContent.vue'
import DocumentacionOficialTabContent from './datos-generales/tab-content/DocumentacionOficialTabContent.vue'
import InformacionPersonalTabContent from './datos-generales/tab-content/InformacionPersonalTabContent.vue'
import DomicilioTabContent from './datos-generales/tab-content/DomicilioTabContent.vue'
import EstudiosTabContent from './datos-generales/tab-content/EstudiosTabContent.vue'

export default {
  components: {
    InformacionPrincipalTabContent,
    NacionalidadTabContent,
    DocumentacionOficialTabContent,
    InformacionPersonalTabContent,
    DomicilioTabContent,
    EstudiosTabContent,
  },
  data() {
    return {
      selectedTab: 0,
    }
  },
  computed: {
    ...mapGetters('personal', {
      personal: 'getPersonalSingle',
    }),
  },
  methods: {
    ...mapActions('personal', ['updatePersonal']),
    async triggerUpdatePersonal() {
      await this.updatePersonal(this.personal)
    },
  },
}
</script>
